import ContributorsLabel from './ContributorsLabel';

export default ContributorsLabel;
